import React, { FC, memo, ReactNode, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { StepperModal, stepperModalActions } from 'features/StepperModal';
import { getOpenedState } from '../model/selectors/getOpenedState';
import { useWatchStep } from '../utils/hooks/useWatchStep';
import { PreviewStep } from './steps/PreviewStep';
import { SelectUserStep } from './steps/SelectUserStep';
import { SelectWarehouseStep } from './steps/SelectWarehouseStep';
import { issueInvoiceModalActions } from '../model/slice/issueInvoiceModalSlice';
import { InvoiceDataStep } from './steps/InvoiceDataStep';
import { InvoiceItemsStep } from './steps/InvoiceItemsStep/InvoiceItemsStep';
import { getSteps } from '../model/selectors/getSteps';

export const IssueInvoiceModal: FC = memo(() => {
  const dispatch = useAppDispatch();

  const isOpened = useAppSelector(getOpenedState);
  const steps = useAppSelector(getSteps);

  useWatchStep();

  const closeModal = useCallback(() => {
    dispatch(issueInvoiceModalActions.resetModalState());
    dispatch(stepperModalActions.changeActiveStepIndex(0));
  }, [dispatch]);

  const stepsContent: ReactNode[] = [
    <SelectUserStep key="1" />,
    <SelectWarehouseStep key="2" />,
    <InvoiceDataStep key="3" />,
    <InvoiceItemsStep key="4" />,
    <PreviewStep key="5" onClose={closeModal} />,
  ];

  return <StepperModal isOpened={isOpened} onClose={closeModal} steps={steps} stepsContent={stepsContent} width={1129} />;
});
